import React from 'react';
import M from 'materialize-css';
import { Link } from 'react-router-dom';

function Badge({ badge }) {
  const copyIdToClipboard = () => {
    navigator.clipboard.writeText(badge.id);
    M.toast({ html: 'ID copied' });
  };

  const renderBadgeData = () => (
    <div className="card-content grey-text text-darken-3">
      <span className="card-email">{badge.name}</span>
      {renderClickableId()}
      {badge.countryCode ? <p className="company-address"> Country: {badge.countryCode}</p> : <p className="company-address">&nbsp;</p>}
      {badge.companyId ? <p className="company-address"> Company id: {badge.companyId}</p> : <p className="company-address">&nbsp;</p>}
      {badge.description ? <p className="company-address"> Description: {badge.description}</p> : <p className="company-address">&nbsp;</p>}
      {badge.quantity ? <p className="company-address"> Quantity: {badge.quantity.toString()}</p> : <p className="company-address">&nbsp;</p>}
      {badge.type ? <p className="company-address"> Type: {badge.type}</p> : <p className="company-address">&nbsp;</p>}
      {badge.subType ? <p className="company-address"> SubType: {badge.subType}</p> : <p className="company-address">&nbsp;</p>}
    </div>
  );

  const renderClickableId = () =>
    badge.id ? (
      <p className="company-address">
        {`ID: `}
        <button className="id-link" onClick={() => copyIdToClipboard()}>
          {badge.id}
        </button>
      </p>
    ) : null;

  return (
    <div className="col s12 m6">
      <div className="card z-depth-0 project-summary">
        {renderBadgeData()}
        <div className="card-action-disabled">
          <Link
            className="btn-flat"
            to={{
              pathname: '/newBadge',
              badge: badge,
              edit: true,
            }}>
            Edit
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Badge;
